import { sendGet, sendPut, type Response } from '../hooks/use-fetch'
import { type ProgressReportDates } from '../models/ProgressReportDates'
import { type SystemTimeSpan } from '../models/SystemTimeSpan'

export type { ProgressReportDates } from '../models/ProgressReportDates'
export type { SystemTimeSpan } from '../models/SystemTimeSpan'

export async function GetProgressReportDates (annualPlanId: number): Promise<Response<ProgressReportDates>> {
  return await sendGet(`SystemConfiguration/ProgressReportDates?annualPlanId=${annualPlanId}`)
}

export async function GetSystemTimeSpans (): Promise<Response<SystemTimeSpan[]>> {
  return await sendGet('SystemConfiguration/TimeSpans')
}

export async function GetSystemConfigValues (systemTimeSpanId: number): Promise<Response<Record<string, string>>> {
  return await sendGet(`SystemConfiguration/ConfigValues?systemTimeSpanId=${systemTimeSpanId}`)
}

export async function UpdateSystemConfigValues (systemTimeSpanId: number, values: Record<string, string>): Promise<Response> {
  return await sendPut('SystemConfiguration/ConfigValues', { systemTimeSpanId, values })
}
